module.exports = __webpack_public_path__ + "static/media/headerImage2.54b42e47.jpg";